import { render, staticRenderFns } from "./ControlPreparation.vue?vue&type=template&id=87ba013a&"
import script from "./ControlPreparation.vue?vue&type=script&lang=js&"
export * from "./ControlPreparation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports